import React from "react";
import { Link } from "react-router-dom";
import './Navigation.css';

const Navigation = () => (
  <nav className="nav-buttons">
    <Link to="/optout" className="button-link">メルマガ配信停止・退会</Link>
    <a
      href="https://eu-phoria.jp/aboutus"
      className="button-link"
      target="_blank"
      rel="noopener noreferrer"
    >
      運営会社情報
    </a>
    <Link to="/inquiry" className="button-link">お問い合わせ</Link>
  </nav>
);

export default Navigation;
